import ApiService from "../../common/services/ApiService";

const api = new ApiService();

export const getUser = async (userId) => {
   try {
      const user = await api.query(`/api/v1/users/${userId}`);
      return user.data;
    } catch (error) {
      console.error('Error fetching user:', error);
    }
}

export const getPointRequest = async (userId, id) => {
   try {
      const pointRequest = await api.query(`/api/v1/users/${userId}/point_requests?q%5Bid_eq%5D=${id}`);
      return pointRequest.data[0];
    } catch (error) {
    } 
}

export const getLastApprovedVcm = async (userId) => {
   try {
      const lastApprovedVcm = await api.query(`/api/v1/vcms/show_last_approved_vcm?user_id=${userId}`);
      return lastApprovedVcm.data;
    } catch (error) {
    }
}